
























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  GetDetailLeftNavDoneList,
  GetDetailLeftNavDoneListZwb,
} from "@/request/edr";
@Component({})
export default class EdrPatientDetailNav extends Vue {
  @Prop()
  private cState: any;
  @Prop()
  private patient: any;
  @Prop()
  private nav: any;
  private cWrap: any = "";
  private zyyx: any[] = [];
  private zwbsj: any[] = [];
  private get ifCompose() {
    return this.$store.state.edrIfCompose;
  }
  @Watch("nav", { deep: true })
  private navChange() {
    this.nav.forEach((item: any) => {
      let exsit: boolean = false;
      item.templates.forEach((template: any) => {
        if (template["名称"] === this.cState) {
          exsit = true;
        }
      });
      if (exsit) {
        this.cWrap = item["访视名称"];
      }
    });
    if (
      this.cState === "舌象数据-科研版" ||
      this.cState === "面象数据" ||
      this.cState === "脉象数据"
    ) {
      this.cWrap = "中医影像";
    }
    if (
      this.cState === "中医体质辨识" ||
      this.cState === "四诊合参体质辨识" ||
      this.cState === "儿童体质辨识" ||
      this.cState === "老年人体质辨识" ||
      this.cState === "备孕女性健康状态测评" ||
      this.cState === "孕期女性健康状态测评" ||
      this.cState === "产后女性健康状态测评" ||
      this.cState === "围绝经期女性健康状态测评" ||
      this.cState === "中医心理测评" ||
      this.cState === "高血压病辅助辨证" ||
      this.cState === "糖尿病辅助辨证"
    ) {
      this.cWrap = "治未病数据";
    }
  }
  @Watch("patient", { deep: true, immediate: true })
  private patientChange() {
    if (this.patient.patient_id) {
      this.fetchDoneList();
    }
  }
  /**
   * @description 检测当前用户中医影像数据和治未病数据
   */
  private fetchDoneList() {
    const params: any = {
      params: {
        patient_id: this.patient.patient_id,
      },
    };
    GetDetailLeftNavDoneList(this, params).then((data: any) => {
      this.zyyx = data;
    });
    GetDetailLeftNavDoneListZwb(this, params).then((data: any) => {
      this.zwbsj = data;
    });
  }
  /**
   * @description 跳转
   */
  private goTo(part) {
    if (this.ifCompose) {
      this.$emit("needSave", part);
      // this.$message.warning("数据尚未保存，请先保存");
    } else {
      this.$emit("jump", part);
    }
  }

  /**
   * @description 切换开关
   */
  private triggerWrap(name) {
    this.cWrap = name;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    // console.log(this.nav);
  }
}
